import { CdkStepper } from '@angular/cdk/stepper';
import { Component } from '@angular/core';

@Component({
  selector: 'miq-stepper',
  templateUrl: 'stepper.component.html',
  providers: [{ provide: CdkStepper, useExisting: StepperComponent }],
  exportAs: 'stepper',
  standalone: false,
})
export class StepperComponent extends CdkStepper {}
